<style lang="scss" src='./SoilType.scss' scoped></style>
<template src="./SoilType.html"></template>

<script>
import SecurityComponent from '@/components/SecurityComponent.vue';
import Placeholder from '@/components/placeholders/Placeholders.vue';
import {
  getSoilTypes,
  postSoilTypes,
  editSoilTypes
} from '@/api/index';
import i18n from '../../../../i18n';

import {
  mapState,
  mapActions,
  mapMutations,
} from 'vuex';

export default {
  name: 'SoilType',
  extends: SecurityComponent,
  components: {
    Placeholder,
  },
  data() {
    return {
      create: true,
      typesAvailable: [],
      newActive: false,
      editType: null,
      typeName: null,
      loading: false,
    };
  },
  computed: {
    orderedTypes() {
      if (this.typesAvailable && this.typesAvailable.length > 0) {
        let getName = this.getLabel;
        return this.typesAvailable.sort(function(a, b) {
          var nameA = getName(a).toUpperCase(); // ignore upper and lowercase
          var nameB = getName(b).toUpperCase(); // ignore upper and lowercase
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        });
      }
    },
  },

  methods: {
    getLabel(item) {
      return item.soil_type_name;
    },

    showNewModal() {
      this.newActive = true;
      this.typeName = null;
      this.$bvModal.show('modal-add-soil-type')
    },

    showEditModal(item) {
      this.loading = false;
      this.editType = item;
      this.typeName = item.soil_type_name;
      this.newActive = false;
      this.$bvModal.show('modal-add-soil-type');
    },
    
    async saveType(){
      this.loading = true;
      if(this.typeName){

        let data = {
          soil_type_name: this.typeName,
        };

        if(this.newActive) {

          postSoilTypes(data).then((resp)=>{
            this.loadData();
            this.$bvModal.hide('modal-add-soil-type');
          })
        } else {
          editSoilTypes(data, this.editType.soil_type_id).then((resp)=>{
            this.loadData();
            this.$bvModal.hide('modal-add-soil-type');
          })
        }

        this.loading = false;
      }
    },

    async loadData() {
      this.loadAvailableTypes();
    },

    loadAvailableTypes() {
      getSoilTypes().then((resp) => {
        if (resp.soil_types && resp.soil_types.length) {
          this.typesAvailable = resp.soil_types.map(type => ({...type, selected: false}));
        } else {
          this.typesAvailable = [];
        }
      })
    },
  },
  async mounted() {
    if (process.env.VUE_APP_SENTRY_ENV == "production") {
      this.$analytics.setCurrentScreen("Web Settings Soil Types");
      this.$analytics.logEvent("web_settings_soil_types");
    }

    this.loadData();
  },
};

</script>
